export const ItemData1 = [
  {
    id: '1',
    preview: '/images/ecommerce/png/1.png',
    title: 'Dapzem & Co',
    oldpr: '$229',
    newpr: '$1,799',
    offerprice: '$229',
    quantity: 1,
  },
  {
    id: '2',
    preview: '/images/ecommerce/png/2.png',
    title: 'Denim Winjo',
    oldpr: '$599',
    newpr: '$2,499',
    offerprice: '$599',
    quantity: 2,
  },
  {
    id: '3',
    preview: '/images/ecommerce/png/3.png',
    title: 'Jimmy Lolfiger',
    oldpr: '$1,199',
    newpr: '$3,299',
    offerprice: '$1,199',
    quantity: 3,
  },
  {
    id: '4',
    preview: '/images/ecommerce/png/4.png',
    title: 'Bluberry Co.In',
    oldpr: '$349',
    newpr: '$1,299',
    offerprice: '$349',
    quantity: 4,
  },
  {
    id: '5',
    preview: '/images/ecommerce/png/5.png',
    title: 'Aus Polo Assn',
    oldpr: '$1,899',
    newpr: '$3,799',
    offerprice: '$1,899',
    quantity: 5,
  },
];
export const Maindata = [
  {
    id: '1',
    preview: '/images/ecommerce/png/1.png',
    title: 'Dapzem & Co',
    description: 'Branded hoodie ethnic style',
    oldpr: '$229',
    newpr: '$1,799',
    offerprice: '$229',
    quantity: 1,
    images: [
      {img: '/images/ecommerce/png/1.png'},
      {img: '/images/ecommerce/png/1.png'},
      {img: '/images/ecommerce/png/1.png'},
    ],
  },
  {
    id: '2',
    preview: '/images/ecommerce/png/2.png',
    title: 'Denim Winjo',
    description: 'Vintage pure leather Jacket',
    oldpr: '$599',
    newpr: '$2,499',
    offerprice: '$599',
    quantity: 2,
    images: [
      {img: '/images/ecommerce/png/2.png'},
      {img: '/images/ecommerce/png/2.png'},
      {img: '/images/ecommerce/png/2.png'},
    ],
    ribbon: '',
  },
  {
    id: '3',
    preview: '/images/ecommerce/png/3.png',
    title: 'Jimmy Lolfiger',
    description: 'Unisex jacket for men & women',
    oldpr: '$1,199',
    newpr: '$3,299',
    offerprice: '$1,199',
    quantity: 1,
    images: [
      {img: '/images/ecommerce/png/3.png'},
      {img: '/images/ecommerce/png/3.png'},
      {img: '/images/ecommerce/png/3.png'},
    ],
    ribbon: '',
  },
  {
    id: '4',
    preview: '/images/ecommerce/png/4.png',
    title: 'Bluberry Co.In',
    description: 'Full sleeve white hoodie',
    oldpr: '$349',
    newpr: '$1,299',
    offerprice: '$349',
    quantity: 1,
    images: [
      {img: '/images/ecommerce/png/4.png'},
      {img: '/images/ecommerce/png/4.png'},
      {img: '/images/ecommerce/png/4.png'},
    ],
    ribbon: '',
  },
  {
    id: '5',
    preview: '/images/ecommerce/png/5.png',
    title: 'Aus Polo Assn',
    description: 'Snow jacket with low pockets',
    oldpr: '$1,899',
    newpr: '$3,799',
    offerprice: '$1,899',
    quantity: 1,
    images: [
      {img: '/images/ecommerce/png/5.png'},
      {img: '/images/ecommerce/png/5.png'},
      {img: '/images/ecommerce/png/5.png'},
    ],
  },
  {
    id: '6',
    preview: '/images/ecommerce/png/6.png',
    title: 'BMW',
    description: 'Ethnic wear jackets form BMW',
    oldpr: '$1,499',
    newpr: '$2,499',
    offerprice: '$1,499',
    quantity: 1,
    images: [
      {img: '/images/ecommerce/png/6.png'},
      {img: '/images/ecommerce/png/6.png'},
      {img: '/images/ecommerce/png/6.png'},
    ],
  },
  {
    id: '7',
    preview: '/images/ecommerce/png/7.png',
    title: 'Denim Corporation',
    description: 'Flap pockets denim jackets for men',
    oldpr: '$299',
    newpr: '$399',
    offerprice: '$299',
    quantity: 1,
    images: [
      {img: '/images/ecommerce/png/7.png'},
      {img: '/images/ecommerce/png/7.png'},
      {img: '/images/ecommerce/png/7.png'},
    ],
    ribbon: '',
  },
  {
    id: '8',
    preview: '/images/ecommerce/png/8.png',
    title: 'Pufa',
    description: 'Ergonic designed full sleeve coat',
    oldpr: '$2,399',
    newpr: '$5,699',
    offerprice: '$2,399',
    quantity: 1,
    images: [
      {img: '/images/ecommerce/png/8.png'},
      {img: '/images/ecommerce/png/8.png'},
      {img: '/images/ecommerce/png/8.png'},
    ],
    ribbon: '',
  },
  {
    id: '9',
    preview: '/images/ecommerce/png/9.png',
    title: 'Louie Phillippe',
    description: 'Ergonic green colored full sleeve jacket',
    oldpr: '$1,899',
    newpr: '$3,299',
    offerprice: '$1,899',
    quantity: 1,
    images: [
      {img: '/images/ecommerce/png/9.png'},
      {img: '/images/ecommerce/png/9.png'},
      {img: '/images/ecommerce/png/9.png'},
    ],
  },

  {
    id: '10',
    preview: '/images/ecommerce/png/10.png',
    title: 'Denim Corp',
    description: 'beautiful brown colored snow jacket',
    oldpr: '$2,499',
    newpr: '$4,999',
    offerprice: '$499',
    quantity: 1,
    images: [
      {img: '/images/ecommerce/png/10.png'},
      {img: '/images/ecommerce/png/10.png'},
      {img: '/images/ecommerce/png/10.png'},
    ],
  },

  {
    id: '11',
    preview: '/images/ecommerce/png/11.png',
    title: 'Garage & Co',
    description: 'Full sleeve sweat shirt',
    oldpr: '$249',
    newpr: '$1,299',
    offerprice: '$249',
    quantity: 1,
    images: [
      {img: '/images/ecommerce/png/11.png'},
      {img: '/images/ecommerce/png/11.png'},
      {img: '/images/ecommerce/png/11.png'},
    ],
  },
  {
    id: '12',
    preview: '/images/ecommerce/png/12.png',
    title: 'Blueberry & Co',
    description: 'Light colored sweater form blueberry',
    oldpr: '$499',
    newpr: '$799',
    offerprice: '$499',
    quantity: 1,
    images: [
      {img: '/images/ecommerce/png/12.png'},
      {img: '/images/ecommerce/png/12.png'},
      {img: '/images/ecommerce/png/12.png'},
    ],
  },
];
